const tabifotoAdmin = {
  tabifotoAdmin: {
    nav: {
      content_section: "內容管理",
      operations_section: "作業管理",
      dashboard: "控制台",
      services: "服務管理",
      portfolio: "作品集管理",
      homepage_display: "首頁顯示設定",
      content: "內容管理",
      orders: "訂單管理",
      photographers: "攝影師管理",
      photographer_applications: "攝影師申請",
      photographer_availability: "可排班管理",
      booking_confirmations: "預訂確認管理",
      legal_documents: "法律文件",
      booking_cost_items: "費用明細",
      booking_notes: "備忘記錄",
      order_cancellation_logs: "取消記錄",
      order_reschedule_logs: "改期記錄",
      relay: "訊息中心",
    },
    lang: {
      zh: "中文",
      en: "EN",
      ja: "日本語",
      label: "語言",
    },
    common: {
      save: "儲存變更",
      cancel: "取消",
      add: "新增",
      edit: "編輯",
      delete: "刪除",
      deactivate: "停用",
      active: "啟用",
      inactive: "未啟用",
      published: "已發布",
      draft: "草稿",
      sort_order: "排序",
      yes: "是",
      no: "否",
      actions: "操作",
      loading: "載入中...",
      error_load: "載入失敗，請重試",
      retry: "重試",
      empty: "尚無資料",
      confirm_delete: "確認刪除此項目？",
      cannot_undone: "此操作無法復原。",
      confirm_deactivate: "確認停用此項目？",
      deactivate_desc: "記錄保留，is_active 將設為 false。",
      save_success: "儲存成功",
      save_error: "儲存失敗，請重試",
      delete_success: "刪除成功",
      delete_error: "刪除失敗",
      api_not_configured: "API 尚未設定，目前顯示示範資料",
    },
    dashboard: {
      title: "控制台",
      subtitle: "TaBiFoTo CMS — 內容與作業管理",
      active_services: "啟用服務",
      published_portfolio: "已發布作品",
      on_showreel: "展示卷軸",
      featured_works: "精選作品",
      active_content: "啟用內容",
      service_options: "服務選項",
      data_tables: "資料表",
      reset_title: "重設為預設值",
      reset_desc: "將所有資料還原為初始示範值，無法復原。",
      reset_button: "重設資料",
      drafts_warning: "{{count}} 件草稿未發布",
      inactive_warning: "{{count}} 項服務已停用",
    },
    services: {
      title: "服務管理",
      subtitle: "管理服務資料表 — 多語言、定價、城市範圍與選項",
      add_service: "新增服務",
      edit_service: "編輯服務",
      col_order: "#",
      col_image: "圖片",
      col_code: "代碼",
      col_title: "名稱（中文）",
      col_price: "價格（台幣）",
      col_hours: "時數",
      col_cities: "城市範圍",
      col_active: "啟用",
      col_sort: "排序",
      col_options: "選項",
      col_actions: "操作",
      service_code: "service_code",
      icon_class: "圖示 Class",
      title_field: "服務名稱",
      short_desc: "簡短描述",
      features: "特色列表",
      add_feature: "+ 新增特色",
      base_price: "基本價格（NT$）",
      duration_hours: "服務時數",
      city_scope: "城市範圍",
      cover_image: "封面圖片網址",
      no_options: "尚無選項",
      manage_options: "選項管理",
      add_option: "新增選項",
      edit_option: "編輯選項",
      option_code: "option_code",
      option_title: "選項名稱",
      price_delta: "加價（NT$）",
      deactivate_confirm: "停用此服務？",
      deactivate_desc: "記錄保留，is_active 將設為 false。",
      opts_label: "{{count}} 項選項",
    },
    portfolio: {
      title: "作品集管理",
      subtitle: "管理 portfolio_items — 展示卷軸、精選、首頁顯示控制",
      add_item: "新增作品",
      edit_item: "編輯作品",
      filter_all: "全部",
      filter_published: "已發布",
      filter_showreel: "展示卷軸",
      filter_featured: "精選",
      col_order: "#",
      col_thumb: "縮圖",
      col_title: "標題",
      col_city: "城市",
      col_shoot_type: "拍攝類型",
      col_showreel: "展示卷軸",
      col_featured: "精選",
      col_published: "發布狀態",
      col_display_mode: "顯示模式",
      col_sort: "排序",
      col_actions: "操作",
      title_field: "標題",
      photographer_id: "攝影師 ID",
      city: "城市",
      shoot_type: "拍攝類型",
      media_type: "媒體類型",
      thumbnail_url: "縮圖網址",
      media_url: "媒體網址",
      description: "描述",
      display_mode: "首頁顯示模式",
      no_items: "無符合條件的作品。",
      delete_confirm: "刪除此作品？",
    },
    homepage: {
      title: "首頁顯示設定",
      subtitle: "控制哪些作品集項目顯示在首頁展示卷軸與精選區塊",
      on_showreel: "展示卷軸",
      featured_works: "精選作品",
      total_published: "已發布總數",
      tab_showreel: "展示卷軸",
      tab_featured: "精選作品",
      tab_all: "全部已發布",
      is_showreel: "展示卷軸",
      is_featured: "精選",
      display_mode: "顯示模式",
      sort_order_field: "排序",
      publish_first: "尚無已發布作品。請先至作品集管理中發布項目。",
    },
    content: {
      title: "內容管理",
      subtitle: "編輯 Hero 文字、理念頁面、CTA — 支援 zh / en / ja",
      add_section: "新增區塊",
      edit_section: "編輯區塊",
      section_key: "section_key",
      image_url: "圖片網址",
      title_field: "標題",
      content_field: "內容",
      no_items: "此區塊尚無記錄。",
      delete_confirm: "刪除此區塊？",
      records_count: "{{count}} 筆記錄",
      hero_label: "Hero",
      hero_desc: "首頁主視覺標題、副標、背景圖片與 CTA 文字",
      philosophy_label: "理念頁面",
      philosophy_desc: "理念頁面 Hero 及 4 個內容區塊",
      cta_label: "CTA 區塊",
      cta_desc: "各頁面的行動呼籲標題與內文",
    },
    orders: {
      title: "訂單管理",
      subtitle: "查看與管理客戶預訂請求 — 訂單狀態與付款狀態追蹤",
      add_order: "新增訂單",
      edit_order: "編輯訂單",
      filter_all: "全部",
      col_order_number: "訂單編號",
      col_customer: "客戶",
      col_city: "城市",
      col_service: "服務",
      col_shoot_date: "拍攝日期",
      col_total: "總金額",
      col_order_status: "訂單狀態",
      col_payment_status: "付款狀態",
      col_actions: "操作",
      customer_name: "客戶姓名",
      customer_email: "電子郵件",
      customer_phone: "電話",
      service_id: "服務",
      selected_city: "城市",
      shoot_date: "拍攝日期",
      start_time: "開始時間",
      end_time: "結束時間",
      number_of_reels: "卷軸數量",
      subtotal_twd: "小計（NT$）",
      addons_total_twd: "加購小計（NT$）",
      total_twd: "總計（NT$）",
      currency: "幣別",
      order_status: "訂單狀態",
      payment_status: "付款狀態",
      special_requests: "特殊需求",
      internal_notes: "內部備註",
      order_status_pending: "待處理",
      order_status_confirmed: "已確認",
      order_status_cancelled: "已取消",
      order_status_completed: "已完成",
      payment_status_unpaid: "未付款",
      payment_status_paid: "已付款",
      payment_status_refunded: "已退款",
      payment_status_partial: "部分付款",
      no_orders: "尚無訂單。",
      delete_confirm: "刪除此訂單？",
      related_records: "關聯記錄",
      related_cost_items: "費用明細",
      related_notes: "備忘記錄",
      related_cancellations: "取消記錄",
      related_reschedules: "改期記錄",
      view_related: "查看",
    },
    photographers: {
      title: "攝影師管理",
      subtitle: "管理攝影師運營資料 — 狀態、語言、城市據點、聯絡方式",
      add_photographer: "新增攝影師",
      edit_photographer: "編輯攝影師",
      col_code: "代碼",
      col_name: "顯示姓名",
      col_legal_name: "法定姓名",
      col_city_base: "城市據點",
      col_languages: "語言",
      col_status: "狀態",
      col_active: "啟用",
      col_actions: "操作",
      photographer_code: "photographer_code",
      display_name: "顯示姓名",
      legal_name: "法定姓名",
      email: "電子郵件",
      phone: "電話",
      country_code: "國家代碼",
      city_base: "城市據點",
      languages: "語言（以逗號分隔，如 zh,en,ja）",
      status: "狀態",
      portfolio_url: "作品集網址",
      notes: "備註",
      status_active: "在職",
      status_inactive: "離職",
      status_on_leave: "請假中",
      status_suspended: "暫停",
      deactivate_confirm: "停用此攝影師？",
      deactivate_desc: "記錄保留，is_active 將設為 false。",
      no_photographers: "尚無攝影師資料。",
      all_count: "共 {{count}} 位攝影師",
      gender_label: "性別（僅供媒合用）",
      gender_note: "此欄位僅作為偏好媒合參考，不對外公開為篩選條件。",
      gender_prefer_not_to_say: "不提供",
      gender_male: "男性",
      gender_female: "女性",
    },
    photographer_availability: {
      title: "可排班管理",
      subtitle: "管理攝影師的可用時段 — 日期、時間、城市、狀態",
      add_availability: "新增時段",
      edit_availability: "編輯時段",
      filter_all: "全部",
      col_photographer: "攝影師",
      col_date: "日期",
      col_time: "時間段",
      col_city: "城市",
      col_status: "狀態",
      col_note: "備註",
      col_actions: "操作",
      photographer_id: "攝影師",
      available_date: "可用日期",
      available_start_time: "開始時間",
      available_end_time: "結束時間",
      city: "城市",
      status: "狀態",
      note: "備註",
      status_available: "可預約",
      status_booked: "已預約",
      status_blocked: "不可用",
      no_availability: "尚無可排班時段。",
      delete_confirm: "刪除此時段記錄？",
    },
    booking_confirmations: {
      title: "預訂確認管理",
      subtitle: "管理訂單的攝影師確認狀態 — 確認、拒絕與替換需求",
      add_confirmation: "新增確認",
      edit_confirmation: "編輯確認",
      filter_all: "全部",
      col_order: "訂單",
      col_photographer: "攝影師",
      col_status: "確認狀態",
      col_confirmed_at: "確認時間",
      col_replacement: "需替換",
      col_note: "備註",
      col_actions: "操作",
      order_id: "訂單",
      photographer_id: "攝影師",
      confirmation_status: "確認狀態",
      confirmed_at: "確認時間",
      declined_at: "拒絕時間",
      replacement_required: "需要替換攝影師",
      note: "備註",
      status_pending: "待確認",
      status_confirmed: "已確認",
      status_declined: "已拒絕",
      status_replacement_needed: "需替換",
      no_confirmations: "尚無預訂確認記錄。",
      delete_confirm: "刪除此確認記錄？",
      unassigned: "未指派",
    },
    legal_documents: {
      title: "法律文件",
      subtitle: "管理服務條款、隱私政策與授權書 — 支援多語言內容",
      add_document: "新增文件",
      edit_document: "編輯文件",
      filter_all: "全部",
      col_doc_type: "文件類型",
      col_doc_key: "Doc Key",
      col_title: "標題",
      col_version: "版本",
      col_effective_date: "生效日期",
      col_active: "啟用",
      col_actions: "操作",
      doc_type: "文件類型",
      doc_key: "Doc Key（系統識別碼）",
      title_field: "標題",
      content_field: "內容",
      version: "版本",
      effective_date: "生效日期",
      no_documents: "尚無法律文件。",
      delete_confirm: "刪除此文件？",
      doc_type_terms: "服務條款",
      doc_type_service_agreement: "攝影服務契約",
      doc_type_cancellation: "取消與改期政策",
      doc_type_privacy: "隱私政策",
      doc_type_photo_release: "照片使用授權書",
      doc_type_photographer_contract: "攝影師契約",
      doc_type_platform_disclaimer: "平台免責聲明",
      doc_type_cross_border: "跨境服務條款",
      audience: "適用對象",
      required_for: "強制要求場景",
      is_mandatory: "是否必填",
      display_order: "顯示排序",
      mandatory_yes: "必填",
      mandatory_no: "選填",
      col_required_for: "強制場景",
    },
    booking_cost_items: {
      title: "費用明細",
      subtitle: "記錄訂單相關的差旅與住宿費用 — 追蹤不可退款費用，支援取消與退款決策",
      add_item: "新增費用",
      edit_item: "編輯費用",
      filter_all: "全部",
      col_order: "訂單",
      col_cost_type: "費用類型",
      col_amount: "金額",
      col_currency: "幣別",
      col_cost_status: "狀態",
      col_description: "說明",
      col_created_at: "建立時間",
      col_actions: "操作",
      order_id: "訂單",
      cost_type: "費用類型",
      amount_twd: "金額（NT$）",
      currency: "幣別",
      cost_status: "費用狀態",
      description: "說明",
      cost_type_flight: "機票",
      cost_type_train: "火車",
      cost_type_accommodation: "住宿",
      cost_type_local_transport: "當地交通",
      cost_type_ticket: "門票",
      cost_type_other: "其他",
      cost_status_estimated: "估計",
      cost_status_booked: "已預訂",
      cost_status_paid: "已付款",
      cost_status_non_refundable: "不可退款",
      no_items: "尚無費用明細。",
      delete_confirm: "刪除此費用記錄？",
      total_label: "合計",
      non_refundable_warning: "不可退款費用應特別注意",
    },
    booking_notes: {
      title: "備忘記錄",
      subtitle: "管理訂單的內部備忘、客戶可見說明與攝影師指示",
      add_note: "新增備忘",
      filter_all: "全部",
      col_order: "訂單",
      col_note_type: "類型",
      col_content: "內容",
      col_created_by: "建立者",
      col_created_at: "建立時間",
      col_actions: "操作",
      order_id: "訂單",
      note_type: "備忘類型",
      content: "內容",
      created_by: "建立者",
      note_type_internal: "內部",
      note_type_customer_visible: "客戶可見",
      note_type_photographer_visible: "攝影師可見",
      no_notes: "尚無備忘記錄。",
      delete_confirm: "刪除此備忘？",
      content_placeholder: "輸入備忘內容...",
    },
    order_cancellation_logs: {
      title: "取消記錄",
      subtitle: "訂單取消稽核記錄 — 包含退款金額、違約金與不可退款費用明細",
      add_log: "新增取消記錄",
      edit_log: "編輯取消記錄",
      filter_all: "全部",
      col_order: "訂單",
      col_cancelled_at: "取消時間",
      col_cancelled_by: "取消方",
      col_refund: "退款金額",
      col_penalty: "違約金",
      col_non_refundable: "不可退款",
      col_actions: "操作",
      order_id: "訂單",
      cancelled_at: "取消時間",
      cancelled_by: "取消方",
      reason: "取消原因",
      refund_amount_twd: "退款金額（NT$）",
      penalty_amount_twd: "違約金（NT$）",
      non_refundable_cost_twd: "不可退款費用（NT$）",
      note: "備註",
      no_logs: "尚無取消記錄。",
      delete_confirm: "刪除此取消記錄？",
      financial_summary: "財務摘要",
      by_customer: "客戶",
      by_ops: "運營方",
    },
    order_reschedule_logs: {
      title: "改期記錄",
      subtitle: "訂單改期稽核記錄 — 追蹤原始日期、新日期、改期次數與審批狀態",
      add_log: "新增改期記錄",
      edit_log: "編輯改期記錄",
      filter_all: "全部",
      filter_pending: "待審批",
      filter_approved: "已審批",
      col_order: "訂單",
      col_original_date: "原始日期",
      col_new_date: "新日期",
      col_requested_at: "申請時間",
      col_approved_at: "審批時間",
      col_count: "改期次數",
      col_actions: "操作",
      order_id: "訂單",
      original_shoot_date: "原始拍攝日期",
      new_shoot_date: "新拍攝日期",
      requested_at: "申請時間",
      approved_at: "審批時間",
      reason: "改期原因",
      reschedule_count: "改期次數",
      note: "備註",
      no_logs: "尚無改期記錄。",
      delete_confirm: "刪除此改期記錄？",
      pending_badge: "待審批",
      approved_badge: "已審批",
    },
    auth: {
      login_title: "管理員登入",
      login_subtitle: "TaBiFoTo 後台管理系統",
      email_label: "電子郵件",
      email_placeholder: "請輸入管理員電子郵件...",
      password_label: "密碼",
      password_placeholder: "請輸入密碼...",
      login_button: "登入",
      logging_in: "驗證中...",
      login_error_invalid: "電子郵件或密碼錯誤，或帳號已停用。",
      login_error_supabase: "資料庫連線未設定，請確認環境設定。",
      login_error_network: "連線失敗，請稍後重試。",
      logout: "登出",
      logged_in_as: "目前登入：",
      bootstrapping: "載入管理面板中...",
      session_expired: "登入已過期，請重新登入。",
    },
  },
};

export default tabifotoAdmin;
